export const commoncodeConstants = {
    GETCOCLASS_REQUEST: 'GETCOCLASS_REQUEST',
    GETCOCLASS_SUCCESS: 'GETCOCLASS_SUCCESS',
    GETCOCLASS_FAILURE: 'GETCOCLASS_FAILURE',

    GETCOSUBCLASS_REQUEST: 'GETCOSUBCLASS_REQUEST',
    GETCOSUBCLASS_SUCCESS: 'GETCOSUBCLASS_SUCCESS',
    GETCOSUBCLASS_FAILURE: 'GETCOSUBCLASS_FAILURE',

    GETZIPADDRSFORISV_REQUEST: 'GETZIPADDRSFORISV_REQUEST',
    GETZIPADDRSFORISV_SUCCESS: 'GETZIPADDRSFORISV_SUCCESS',
    GETZIPADDRSFORISV_FAILURE: 'GETZIPADDRSFORISV_FAILURE',

    GET_IDENTITY_REQUEST: 'COMMON_GET_IDENTITY_REQUEST',
    GET_IDENTITY_SUCCESS: 'COMMON_GET_IDENTITY_SUCCESS',
    GET_IDENTITY_FAILURE: 'COMMON_GET_IDENTITY_FAILURE',
    
    GETCOCLASS_FAILURE: 'GETCOCLASS_CLOSE'
}
